import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const ContractTypeField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`resources.contracts.types.${record[source]}`) } </span>
      );
};

ContractTypeField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default ContractTypeField;
